import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'saltoLinea'
})
export class SaltoLineaPipe implements PipeTransform {

  transform(value: string): string {
   
    return value.replace(/\n/g, '<br>');
  }

}